import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// When the service worker handles a push notification click, it posts
// { type: 'NAVIGATE', url } to all focused clients. We route client-side
// via React Router so the tab doesn't do a full reload on every tap.
// Mount once inside the Router tree.
export function usePushNavigation() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    function onMessage(event: MessageEvent) {
      const data = event.data as { type?: string; url?: string } | null;
      if (data?.type === 'NAVIGATE' && typeof data.url === 'string') {
        navigate(data.url);
      }
    }

    navigator.serviceWorker.addEventListener('message', onMessage);
    return () => {
      navigator.serviceWorker.removeEventListener('message', onMessage);
    };
  }, [navigate]);
}
